import BodyModalWithActions from '../../../../components/common/modals/bodyModalWithActions'
import { Typography } from '@mui/material'
import { t } from 'i18next'
const BodyModalConfirmResendInvitation = () => {
  return (
    <BodyModalWithActions
      title={t('pages.users.resendInvitationTitle') as string}
      type='confirm'
      content={
        <Typography sx={{ my: '16px!important' , textAlign: 'center' }}>
          {t('pages.users.resendInvitationDescription')}
        </Typography>
      }
    />
  )
}

export default BodyModalConfirmResendInvitation
